'use client'

import { ReducersMapObject } from '@reduxjs/toolkit'
import persistStore from 'redux-persist/es/persistStore'
import { Persistor } from 'redux-persist/es/types'

import { ReactNode, useRef } from 'react'

import { Provider } from 'react-redux'

import { Persist } from '../components/SSROutset'
import { StateSchema } from '../config/StateSchema'
import { PersistorContext } from '../config/persistorContext'
import { createReduxStore } from '../config/store'
import { AppStore } from '../store'

interface StoreProviderProps {
  children?: ReactNode
  initialState?: StateSchema
  asyncReducers?: ReducersMapObject<StateSchema>
}

export const StoreProvider = (props: StoreProviderProps) => {
  const { children, initialState, asyncReducers } = props

  const storeRef = useRef<AppStore | undefined>()
  const persistorRef = useRef<Persistor>({} as Persistor)

  if (!storeRef.current) {
    storeRef.current = createReduxStore(
      initialState as StateSchema,
      asyncReducers as ReducersMapObject<StateSchema>,
    )
    if (storeRef.current) {
      persistorRef.current = persistStore(storeRef?.current)
    }
  }

  return (
    <Provider store={storeRef?.current}>
      <Persist persistor={persistorRef?.current}>
        <PersistorContext.Provider value={persistorRef?.current}>
          {children}
        </PersistorContext.Provider>
      </Persist>
    </Provider>
  )
}
